import React from "react";
import SoybeansIcon from "../../../assets/images/commodityIcons/Soybeans.png";
import ipBeansBg from "../../../assets/images/collwest/ip-beans.png";
import styles from "../styles";

function IPSoybean() {
  const headerStyle = {
    backgroundColor: styles.primaryColor,
  };

  return (
    <div className="w-full h-full mt-[100px] flex flex-col">
      <div
        className="relative flex flex-col justify-center items-center h-[400px] w-full bg-cover bg-center bg-no-repeat text-white"
        style={{
          backgroundImage: `url(${ipBeansBg})`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <h1 className="relative z-10 text-3xl md:text-4xl font-bold text-center mb-3">
          IP Soybean Program
        </h1>
        <p className="relative z-10 text-base md:text-xl text-center w-11/12 md:w-2/3">
          2025 IP Premiums now available. For more information call our
          Collingwood office
        </p>
      </div>
      <div className="w-full h-full flex flex-col items-center px-4 md:px-8 lg:px-16 pb-12">
        <div className="max-w-5xl w-full mt-8">
          <section className="mb-12">
            <div className="flex items-center gap-2 mb-4">
              <img src={SoybeansIcon} alt="IP Soybeans" className="w-14 h-14" />
              <h2 className="text-xl font-semibold">Premium Varieties</h2>
            </div>

            <div className="bg-white shadow-sm rounded-md overflow-hidden mb-4">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead>
                    <tr>
                      <th
                        className="text-white py-2 px-4 text-left text-xs md:text-sm"
                        style={headerStyle}
                      >
                        Variety
                      </th>
                      <th
                        className="text-white py-2 px-4 text-left text-xs md:text-sm"
                        style={headerStyle}
                      >
                        Premium
                      </th>
                      <th
                        className="text-white py-2 px-4 text-left text-xs md:text-sm"
                        style={headerStyle}
                      >
                        Description
                      </th>
                      <th
                        className="text-white py-2 px-4 text-left text-xs md:text-sm"
                        style={headerStyle}
                      >
                        Location
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="bg-gray-50">
                      <td className="py-3 px-4 text-sm md:text-base">S03-W4</td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        $4.00/bushel
                      </td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        <div>
                          Adapted to all soil types and tillage practices.
                        </div>
                        <div>Excellent disease and lodging resistance.</div>
                      </td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        <div>Highland Custom Farming</div>
                        <div>On-Farm Storage</div>
                      </td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 text-sm md:text-base">
                        OAC Strives
                      </td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        $4.00/bushel
                      </td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        <div>Adapted well for narrow rows.</div>
                        <div>
                          Adapted to all soil types and tillage practices.
                        </div>
                        <div>Excellent disease and lodging resistance.</div>
                      </td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        <div>Collwest Grain</div>
                        <div>Highland Custom Farming</div>
                        <div>On-Farm Storage</div>
                      </td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="py-3 px-4 text-sm md:text-base">S04-K9</td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        $4.50/bushel
                      </td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        <div>SCN resistant</div>
                        <div>Excellent emergence</div>
                        <div>Early season vigour and wide adaptability</div>
                      </td>
                      <td className="py-3 px-4 text-sm md:text-base">
                        <div>Collwest Grain</div>
                        <div>On-Farm Storage</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            
              <div className="py-2 px-4 text-center">
                <h3 className="font-medium">* On-farm storage is an option for all growers. A storage premium of $0.40/bushel FOB the farm is available.</h3>
              <h3 className="font-medium mt-12">
              IP Field Map link - <a href="https://inetsgi.com/customer/887/9b03df1d.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 hover:underline">Click Here</a>
              </h3>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default IPSoybean;
